var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H2C0.89543 4 0 4.89543 0 6V12C0 13.1046 0.895431 14 2 14H12C13.1046 14 14 13.1046 14 12V6C14 4.89543 13.1046 4 12 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15.5H2.85867C1.51559 16.87 0.563626 18.9134 0.183482 21.0111C-0.0134775 22.098 0.895535 23 2.0001 23C2.00011 20.2386 4.23868 18 7.00011 18C9.76153 18 12.0001 20.2386 12.0001 23H20.0001C20.0001 20.2386 22.2387 18 25.0001 18C27.7535 18 29.9871 20.2256 30 22.976C31.03 22.815 31.7766 21.8664 31.4369 20.8436C30.0827 16.7662 26.1716 13.4267 21.3501 13L21.0001 9.5C21.0001 8.94772 20.5524 8.5 20.0001 8.5C19.4478 8.5 19.0001 8.94772 19.0001 9.5L19.7555 17.8642C19.887 19.3765 18.6949 20.6768 17.1769 20.6768C14.3178 20.6768 12.0001 18.3591 12.0001 15.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 23C28.5 24.933 26.933 26.5 25 26.5C23.067 26.5 21.5 24.933 21.5 23C21.5 21.067 23.067 19.5 25 19.5C26.933 19.5 28.5 21.067 28.5 23Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26.5C8.933 26.5 10.5 24.933 10.5 23C10.5 21.067 8.933 19.5 7 19.5C5.067 19.5 3.5 21.067 3.5 23C3.5 24.933 5.067 26.5 7 26.5Z",
    fill: "currentColor"
  })));
};
export default SvgDelivery;